import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { initVisitorTracker, trackPageview, getLastVisitedPath } from "@/lib/visitorTracker";

const FN_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/track-visitor`;
const ANON = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
const RESUME_KEY = "vss_visitor_resume_shown";

/**
 * Mounted once at app root. Boots the anonymous tracker, logs every
 * route change as a pageview, and shows a one-time "welcome back" toast
 * to returning visitors who landed back on `/`.
 */
export default function VisitorTrackerBoot() {
  const location = useLocation();
  const { toast } = useToast();

  // boot once
  useEffect(() => {
    initVisitorTracker({ endpoint: FN_URL, anonKey: ANON });
  }, []);

  // pageview per route change
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
